"use client";
import React from "react";
import { motion } from "framer-motion";

const ServicesSection = () => {
  const services = [
    {
      title: "Desserts",
      description: "Sweet cravings? We got you. From soft pastries to loaded brownies and creamy cupcakes — everything’s baked fresh and made to vibe with your mood.",
      icon: "🧁"
    },
    {
      title: "Home Delivery",
      description: "Stay in your PJs, we’ll bring the sugar rush to you. Fast delivery, zero drama, always fresh.",
      icon: "🚚"
    },
    {
      title: "Cake Design",
      description: "Your cake, your rules. Pick the flavor, theme, and vibe — we’ll turn your idea into a total showstopper.",
      icon: "🎨"
    },
    {
  title: "Custom Cakes",
  description: "Designed just for you — from flavors to frosting, every detail is crafted to match your vision and make your celebrations unforgettable.",
  icon: "🎂"
}
  ];

  return (
    <motion.section
      className="flex overflow-hidden flex-col items-center px-4 md:px-16 pt-11 pb-28 w-full bg-[#FEF7F1] max-md:pb-24"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      aria-labelledby="services-title"
    >
      <motion.h2
        id="services-title"
        className="text-4xl md:text-6xl font-semibold text-red-500 text-center"
        style={{ fontFamily: "'Sansita Swashed', cursive" }}
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Services we provide
      </motion.h2>

      <motion.div
        className="flex gap-4 md:gap-6 items-center mt-5 justify-center"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/a004749eeafe96650e9f1ab184dc488f2a5d7166?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative line left"
          className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[171px]"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/e146accfc39e5657464e52c2fa7da78cc6a7866e?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative cupcake element"
          className="object-contain self-stretch my-auto aspect-square w-[25px] md:w-[35px]"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/42135f6d9b1a4837d8746dac7416759042e4672d?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative line right"
          className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[172px]"
        />
      </motion.div>

      <div className="self-stretch mt-3 mb-0 w-full max-w-6xl mx-auto">
        <div className="overflow-hidden w-full text-center text-slate-500">
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 justify-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            {services.map((service, index) => (
              <motion.article
                key={service.title}
                className="flex flex-col items-center p-6 rounded-2xl transition-all duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 + index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="text-4xl md:text-5xl mb-4">
                  {service.icon}
                </div>
                <div className="flex flex-col items-center">
                  <h3
                    className="text-lg md:text-xl tracking-wider leading-7 mb-3 text-cyan-900"
                    style={{ fontFamily: "'Foolish Talk', cursive" }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-sm leading-5 text-center">
                    {service.description}
                  </p>
                </div>
              </motion.article>
            ))}
          </motion.div>
        </div>

        {/* <motion.div
          className="flex flex-wrap gap-1 items-start pt-1.5 pb-1.5 w-full justify-center mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          viewport={{ once: true }}
        >
          <div className="flex shrink-0 w-2.5 h-2.5 rounded-md bg-slate-500" />
          <div className="flex shrink-0 w-2.5 h-2.5 bg-rose-400 rounded-md" />
        </motion.div> */}
      </div>
    </motion.section>
  );
};

export default ServicesSection;
